import styled, { css } from 'styled-components'

export const ContainerWrapper = styled.div<{
    isFlex?: boolean
    marginBottom?: number
    marginRight?: number
    marginLeft?: number
    marginTop?: number
}>`
    background-color: #fff;
    border-radius: 6px;
    padding: 24px;
    display: ${({ isFlex }) => (isFlex ? 'flex' : 'block')};
    ${({ marginBottom }) => {
        if (!marginBottom) {
            return ''
        }
        return css`
            margin-bottom: ${marginBottom}px;
        `
    }}
    ${({ marginRight }) => {
        if (!marginRight) {
            return ''
        }
        return css`
            margin-right: ${marginRight}px;
        `
    }}
    ${({ marginTop }) => {
        if (!marginTop) {
            return ''
        }
        return css`
            margin-top: ${marginTop}px;
        `
    }}
    ${({ marginLeft }) => {
        if (!marginLeft) {
            return ''
        }
        return css`
            margin-left: ${marginLeft}px;
        `
    }}
`

export const Title = styled.p<{ color?: string; fontSize?: number; removeSpace?: boolean; paddingRight?: number }>`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : 16)}px;
    line-height: 15px;
    font-weight: 700;
    margin-bottom: ${({ removeSpace }) => (removeSpace ? '0' : '16px')};
    color: ${({ color }) => (color ? color : '#333')};
    ${({ paddingRight }) => {
        if (!paddingRight) {
            return ''
        }
        return css<{ paddingRight?: number }>`
            padding-right: ${({ paddingRight }) => paddingRight}px;
        `
    }}
`
